import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PropTypes, { any } from 'prop-types';

import { required } from '../../../../utils/form-validation';
import {
    TitleSwitch,
    DateTimePicker,
} from '../../../Form';

const SwitchDivisionDate = (props) => {
    const {
        formApi,
        coreUI,
    } = props;

    const { values, error, setValue } = formApi;

    const [showSwitchDivisionDate, setShowSwitchDivisionDate] = useState(values?.switchDivisionAllowed || false);
    const [maxSwitchDivisionDate, setMaxSwitchDivisionDate] = useState();
    const [tourDateEnd, setTourDateEnd] = useState();
    const [regDateStart, setRegDateStart] = useState();
    const [regDateEnd, setRegDateEnd] = useState();

    useEffect(() => {
        if (values?.eventSchedule) {
            const { eventSchedule, maxSwitchDivisionDateUtc } = values;
            const timeZone = eventSchedule.timeZone || 77;
            const timeZoneObj = coreUI.types.timeZones.find(tz => { return tz.id === parseInt(timeZone); });

            setRegDateStart(moment.utc(eventSchedule.registrationStartUtc).tz(timeZoneObj.value));
            setRegDateEnd(moment.utc(eventSchedule.registrationEndUtc).tz(timeZoneObj.value));
            setTourDateEnd(moment.utc(eventSchedule.eventEndUtc).tz(timeZoneObj.value));
            if (maxSwitchDivisionDateUtc && !maxSwitchDivisionDate) {
                setMaxSwitchDivisionDate(moment.utc(maxSwitchDivisionDateUtc).tz(timeZoneObj.value));
            }
        }
    }, [values, coreUI.types.timeZones]);

    const handleDateChange = (key, date) => {
        if (key === 'maxSwitchDivisionDateUtc' && date?.isBefore(tourDateEnd)) {
            setMaxSwitchDivisionDate(date);
            setValue('switchDivisionAllowed', true);
            setValue('maxSwitchDivisionDateUtc', date.toISOString());
        }
        formApi.validate(formApi.values);
    };

    const toggleSwitchDivisionDate = () => {
        if (showSwitchDivisionDate) {
            setShowSwitchDivisionDate(!showSwitchDivisionDate);
            setValue('switchDivisionAllowed', false);
            setMaxSwitchDivisionDate();
            formApi.reset('maxSwitchDivisionDateUtc');
            formApi.validate(formApi.values);
        } else {
            setShowSwitchDivisionDate(!showSwitchDivisionDate);
            setValue('switchDivisionAllowed', true);
            // default to registration end date
            setMaxSwitchDivisionDate(regDateEnd);
            setValue('maxSwitchDivisionDateUtc', regDateEnd.toISOString());
        }
    };

    return (
        <div className="col-12">
            <div className={`form-block-content`}>
                <div className="row">
                    <div className="col-12">
                        <div className="div div16" />
                        <TitleSwitch
                            id="switchDivisionDate"
                            formGroupCssClass={`mt16`}
                            label={'Allow players to switch divisions'}
                            description={`If enabled, players are allowed to switch divisions without contacting the tournament provider until the specified date. After this date, switch requests can only be initiated by the tournament provider.`}
                            value={showSwitchDivisionDate}
                            onChange={toggleSwitchDivisionDate}
                        />
                    </div>
                </div>
                {showSwitchDivisionDate && (
                    <div className="row">
                        <div className={`col-12 ${error?.regEnd ? 'is-invalid' : ''}`}>
                            <div className="bg-white p16">
                                <DateTimePicker
                                    label="Max player switch date"
                                    id="maxSwitchDivisionDate"
                                    field="maxSwitchDivisionDateUtc"
                                    placeholderText="Select Date"
                                    selected={maxSwitchDivisionDate}
                                    minDate={regDateStart}
                                    maxDate={tourDateEnd}
                                    handleDateChange={(date) => handleDateChange('maxSwitchDivisionDateUtc', date)}
                                    validate={showSwitchDivisionDate && required}
                                    themeV3
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

SwitchDivisionDate.propTypes = {
    formApi: PropTypes.objectOf(any).isRequired,
    coreUI: PropTypes.objectOf(any).isRequired,
};

function mapStateToProps({ coreUI }) {
    return { coreUI };
}

export default connect(mapStateToProps)(SwitchDivisionDate);
